import React from 'react';

const Cart = () => {
  return <div></div>;
};

export default Cart;
